import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ backgroundColor: '#0A192F', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
      <div className="page-container py-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <span className="font-serif text-xl font-bold text-white tracking-tight">
              UNI<span style={{ color: '#C59B6C' }}>KOL</span>
            </span>
            <p className="mt-3 text-sm" style={{ color: '#7A828A' }}>
              Plateforme d'accompagnement multidimensionnel pour les étudiants internationaux de l'Université de Kolwezi.
            </p>
          </div>
          <div>
            <p className="text-[11px] font-semibold tracking-widest uppercase mb-3" style={{ color: '#7A828A' }}>Liens rapides</p>
            <div className="space-y-2 text-sm" style={{ color: '#88929B' }}>
              <Link to="/logements" className="block hover:text-white transition-colors">Logements</Link>
              <Link to="/guide" className="block hover:text-white transition-colors">Guide de Kolwezi</Link>
              <Link to="/demarches" className="block hover:text-white transition-colors">Démarches</Link>
            </div>
          </div>
          <div>
            <p className="text-[11px] font-semibold tracking-widest uppercase mb-3" style={{ color: '#7A828A' }}>Contact</p>
            <p className="text-sm" style={{ color: '#7A828A' }}>
              Université de Kolwezi<br />
              Kolwezi, République Démocratique du Congo
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 text-center text-xs" style={{ borderTop: '1px solid rgba(255,255,255,0.08)', color: '#5A626A' }}>
          &copy; {new Date().getFullYear()} UNIKOL. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
}
